<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50! hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative max-h-full rounded-lg bg-primary-purple-light-2 min-w-1/3">
    <div class="p-8">
      <div class="flex flex-row justify-between items-center mb-6">
        <span class="text-lg font-bold">{{ title() }}</span>
        <div class="flex justify-center items-center cursor-pointer" (click)="close()">
          <img [src]="images.close" alt="closeModal" class="w-6 h-6" />
        </div>
      </div>
      @if (!loading() || confirmStep()! < 3) {
        @if (confirmStep() === 0) {
          <div class="flex flex-col gap-4">
            <span>{{ literalService.get('services.routes.actions.scheduleUpdate.description', true) }}</span>
            <div class="flex flex-row gap-4">
              <div class="flex flex-col gap-1 w-full">
                <label>{{ literalService.get('services.routes.actions.scheduleUpdate.dateLabel', true) }}</label>
                <app-input
                  [data]="scheduleDateElement"
                  [edit]="true"
                  [independent]="false"
                  (setEventEmitter)="onScheduleDateChange($event)"
                  (changeEventEmitter)="onScheduleDateChange($event)"
                />
              </div>
              <div class="flex flex-col gap-1 w-full">
                <label>{{ literalService.get('services.routes.actions.scheduleUpdate.timeLabel', true) }}</label>
                <app-input
                  [data]="scheduleTimeElement"
                  [edit]="true"
                  [independent]="false"
                  (setEventEmitter)="onScheduleTimeChange($event)"
                  (changeEventEmitter)="onScheduleTimeChange($event)"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-row gap-4 mt-8">
            <button type="button" class="secondary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="close()">{{ literalService.get('cancel', true) }}</button>
            <button type="button" class="primary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" [ngClass]="{'disabled cursor-not-allowed': !scheduleComplete}" (click)="onConfirmSchedule()">{{ literalService.get('continue', true) }}</button>
          </div>
        }
        @if (confirmStep() === 1) {
          <div class="flex flex-col gap-4">
            <span>{{ literalService.get('services.routes.design.update.description', true) }}</span>
            @if (mode() !== RouteEditMode.ALTERATIONS) {
              <div class="flex flex-col gap-4">
                <div class="flex items-center gap-1">
                  <input id="futureExpeditions" type="radio" class="radio radio-xs" name="expeditionTypeToUpdate" [checked]="!showPreview" (change)="showPreview = false" />
                  <label for="futureExpeditions" class="cursor-pointer">{{ literalService.get('services.routes.design.update.futureExpeditions', true) }}</label>
                </div>
                <div class="flex items-center gap-1">
                  <input id="allExpeditions" type="radio" class="radio radio-xs" name="expeditionTypeToUpdate" [checked]="showPreview" (change)="showPreview = true" />
                  <label for="allExpeditions" class="cursor-pointer">{{ literalService.get('services.routes.design.update.allExpeditions', true) }}</label>
                </div>
              </div>
            }
          </div>
          @if (showPreview || mode() === RouteEditMode.ALTERATIONS) {
            <div class="flex flex-col gap-4 mt-6">
              <div class="flex flex-col gap-1">
                <div class="flex flex-row gap-1">
                  <img [src]="images.sidebar.trips" class="w-5 h-5 purple-light-icon" alt="trips" />
                  <label>{{ literalService.get('services.routes.design.update.expeditions.title', true) }}</label>
                </div>
                <app-input
                  [data]="expeditionStatusesElement"
                  [edit]="true"
                  [independent]="false"
                  (setEventEmitter)="onExpeditionStatusChange($event)"
                />
              </div>
            </div>
          }
          <div class="flex flex-row gap-4 mt-8 items-center">
            <button type="button" class="secondary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="scheduling() ? cancelAction.emit(null) : close()">{{ literalService.get(scheduling() ? 'back' : 'cancel', true) }}</button>
            <button type="button" class="primary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="onConfirmUpdate()">{{ literalService.get('continue', true) }}</button>
          </div>
        } @else if (confirmStep() !== 0) {
          <div class="flex flex-col gap-4 h-[60vh]">
            <label class="shrink-0">{{ literalService.get('services.routes.design.update.review.description', true) }}</label>
            <div class="flex flex-row gap-6 flex-1 min-h-0">
              <app-route-design-preview
                [routes]="previewChanges()"
                [loadingBookings]="loading()!"
                [allowExcluding]="allowExcluding()"
                [exludedTripIds]="excludedTripsIds"
                (onExcludeTripId)="onExcludeTrip($event)"
                (onRouteSelect)="onPreviewRouteSelect($event)"
              />
              <div class="flex flex-col justify-between mt-11 min-w-[313px]">
                <div class="flex flex-col gap-8">
                  <div class="flex flex-col gap-3">
                    <div class="flex flex-row gap-2 items-center">
                      <img [src]="images.routes.notify" alt="notify" class="w-5 h-5 purple-light-icon" />
                      <label>{{ literalService.get(`services.routes.design.update.review.notify.title`, true) }}</label>
                    </div>
                    <div class="flex flex-col gap-2">
                      @for (notification of notificationOptions; track $index) {
                        <div class="flex items-center gap-1">
                          <input [id]="notification" type="radio" class="radio radio-xs" name="rebuild-notification" [checked]="notificationOption === notification" (change)="notificationOption = notification" />
                          <label [for]="notification" class="cursor-pointer">{{ literalService.get(`services.routes.design.update.review.notify.${notification}`, true) }}</label>
                        </div>
                      }
                    </div>
                  </div>
                  @if (showRefundOptions) {
                    <div class="flex flex-col gap-3">
                      <div class="flex flex-row gap-2 items-center">
                        <img [src]="images.routes.refund" alt="refund" class="w-5 h-5 purple-light-icon" />
                        <label>{{ literalService.get(`services.routes.design.update.review.refund.title`, true) }}</label>
                      </div>
                      <div class="flex flex-col gap-2">
                        @for (refund of refundOptions; track $index) {
                          <div class="flex items-center gap-1">
                            <input [id]="refund" type="radio" class="radio radio-xs" name="rebuild-refund" [checked]="refundOption === refund" (change)="refundOption = refund" />
                            <label [for]="refund" class="cursor-pointer">{{ literalService.get(`services.routes.design.update.review.refund.${refund}`, true) }}</label>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (showRelatedOptions) {
                    <div class="flex flex-row gap-4">
                      <app-toggle [id]="'deleteRelated'" [checked]="deleteRelated" (change)="deleteRelated = !deleteRelated"></app-toggle>
                      <label>{{ literalService.get(`services.routes.design.update.review.related.delete`, true) }}</label>
                    </div>
                  }
                </div>
                <div class="flex flex-row gap-4 mt-8 items-center">
                  <button type="button" class="secondary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="cancelAction.emit(null)">{{ literalService.get('back', true) }}</button>
                  <button type="button" class="primary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="onConfirmUpdate()">{{ literalService.get('update', true) }}</button>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        <article class="flex w-full justify-center items-center mb-9">
          <ng-lottie class="w-24" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
        </article>
        <div class="pb-6 flex flex-col w-[75%] mx-auto min-w-1/2">
          <div class="flex justify-between items-center mb-2">
            <label class="text-[18px] font-semibold text-primary-purple-light">{{ literalService.get(loadingTitle(), true) }}...</label>
            @if (hasPercentage) {
              <label class="text-[18px] font-semibold text-primary-purple-light">{{ loadingPercentage() }}%</label>
            }
          </div>
          <div class="flex justify-center">
            @if (hasPercentage) {
              <progress class="progress text-primary-purple-light" [value]="loadingPercentage()" max="100"></progress>
            } @else {
              <progress class="progress text-primary-purple-light"></progress>
            }
          </div>
          <label class="mt-2 block w-0 min-w-full text-base font-normal truncate text-center" [hidden]="!hasPercentage || !loadingDetail()">{{ loadingDetail() }}</label>
        </div>
      }
    </div>
  </div>
</div>